import React from 'react';
import PropTypes from 'prop-types'

const offerContainerStyle = {
  maxWidth: '310px',
  height: '150px',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.19)',
  borderRadius: '10px',
  cursor: 'pointer',
  marginRight: 20
};

const offerStyle = {
  // width: '300px',
  // height: '150px',
  // borderTopLeftRadius: '9.5px',
  // borderTopRightRadius: '9.5px',
  // backgroundColor : 'transparent',
  objectFit: "none"
};

const promoBlockStyle = {
  width: '300px',
  height: '56px',
  backgroundColor: '#ffffff',
  borderBottomLeftRadius: '9.5px',
  borderBottomRightRadius: '9.5px',
}

const promoCodeStyle = {
  fontFamily: 'OpenSans',
  fontSize: '15px',
  fontWeight: '600',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#4a4a4a',
  margin: '0',
  padding: '5px 15px',
  width: '300px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const promoDesc = {
  fontFamily: 'OpenSans',
  fontSize: '13px',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#4a4a4a',
  margin: '0',
  padding: '0 15px',
};

const code = {
  textTransform : 'uppercase',
};

export default class Card extends React.Component {

  handleClick = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  render() {
    const { url, image_url, name, title, isText } = this.props;

    return (
      <div className="OfferContainer" style={offerContainerStyle}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={this.handleClick}
        >
          <img className="OfferCard" src={image_url} style={offerStyle} alt="offer" />
        </a>
        {
          isText &&
          <div className="PromoBlock" style={promoBlockStyle}>
            <p className="PromoCode" style={promoCodeStyle}>
              Use promocode : <span style={code}>{name}</span>
            </p>
            <p className="PromoDesc" style={promoDesc}>{title}</p>
          </div>
        }
      </div>   
    );
  }
}

Card.defaultProps = {
  url: '#',
  image_url: '',
  name: '',
};

Card.propTypes = {
  Links: PropTypes.arrayOf(PropTypes.string),
  item: PropTypes.object,
  onClick: PropTypes.func
};
